var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00488281,
    width: 40.0026,
    height: 40.0026,
    rx: 10.6663,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_5450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1281 11.251C18.9108 9.48829 21.4123 9.48829 22.195 11.251V11.251C22.676 12.3342 23.9218 12.8503 25.0279 12.4244V12.4244C26.8278 11.7314 28.5967 13.5003 27.9037 15.3002V15.3002C27.4779 16.4063 27.9939 17.6521 29.0771 18.1331V18.1331C30.8398 18.9158 30.8398 21.4174 29.0771 22.2V22.2C27.9939 22.681 27.4779 23.9268 27.9037 25.0329V25.0329C28.5967 26.8328 26.8278 28.6017 25.0279 27.9087V27.9087C23.9218 27.4829 22.676 27.9989 22.195 29.0821V29.0821C21.4123 30.8448 18.9108 30.8448 18.1281 29.0821V29.0821C17.6471 27.9989 16.4013 27.4829 15.2952 27.9087V27.9087C13.4953 28.6017 11.7264 26.8328 12.4194 25.0329V25.0329C12.8452 23.9268 12.3292 22.681 11.246 22.2V22.2C9.48328 21.4174 9.48328 18.9158 11.246 18.1331V18.1331C12.3292 17.6521 12.8452 16.4063 12.4194 15.3002V15.3002C11.7264 13.5003 13.4953 11.7314 15.2952 12.4244V12.4244C16.4013 12.8503 17.6471 12.3342 18.1281 11.251V11.251Z",
    stroke: "black",
    strokeWidth: 1.6869
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.1615,
    cy: 20.1668,
    r: 3.37379,
    stroke: "black",
    strokeWidth: 1.6869
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_5450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6696,
    height: 26.6696,
    fill: "white",
    transform: "translate(6.66638 6.67139)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsNav);
export default __webpack_public_path__ + "static/media/settings-nav.bb4a6d36d44702342538d595fdbf14e4.svg";
export { ForwardRef as ReactComponent };